<template>
  <div class="home">
    <Hero/>
    <Explore/>
    <CoachList/>
    <Features/>
    <HowItWorks/>
    <About/>
    <Articles/>
    <Testimonials/>
    <CallToAction/>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue';
import Hero from '@/components/Hero.vue';

// lazy loaded components after Hero
const Explore = defineAsyncComponent(()=> import('@/components/Explore.vue'))
const CoachList = defineAsyncComponent(()=> import('@core/components/CoachList.vue'))
const Testimonials = defineAsyncComponent(()=> import('@/components/Testimonials.vue'))
const Articles = defineAsyncComponent(()=> import('@/components/Articles.vue'))
const About = defineAsyncComponent(()=> import('@/components/About.vue'))
const HowItWorks = defineAsyncComponent(()=> import('@/components/HowItWorks.vue'))
const Features = defineAsyncComponent(()=> import('@/components/Features.vue'))
const CallToAction = defineAsyncComponent(()=> import('@/components/CallToAction.vue'))

</script>
